import React, { ReactElement } from 'react';
import ConfirmModal from '../confirm-modal/confirm-modal.component';

const LeaveConfirmModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    isSubModal,
    errorMessage,
    onConfirm,
    onCloseModal,
  } = props;

  const leaveConfirmModalTitle: string = 'Unsaved Changes';
  const leaveConfirmModalText: string = 'Are you sure you want to discard your changes?';

  return (
    <ConfirmModal
      isOpen={isOpen}
      isSubModal={isSubModal}
      title={leaveConfirmModalTitle}
      text={leaveConfirmModalText}
      errorMessage={errorMessage}
      onConfirm={onConfirm}
      onCloseModal={onCloseModal}
    />
  );
});

export default LeaveConfirmModal;
